import React from 'react';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import { useSelector } from 'react-redux';
import { useTheme } from '@mui/material/styles';
import { useMediaQuery } from '@mui/material';

import OptionTbl from './Table';

import { 
  callGreekHeaders, 
  callHeaders, 
  putGreekHeaders, 
  putHeaders 
} from "./OptionsFormatter";

const StyledBox = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' 
    ? 'rgba(10, 25, 41, 0.8)' 
    : 'rgba(255,255,255,0.9)',
  borderRadius: theme.spacing(2),
  border: `1px solid ${theme.palette.mode === 'dark' 
    ? 'rgba(255,255,255,0.12)' 
    : theme.palette.divider}`,
  marginBottom: theme.spacing(1),
  display: 'flex',
  flexDirection: 'column',
  height: 'auto',
  maxHeight: '100%',
  touchAction: 'none',
  position: 'relative',
  overflow: 'hidden'
}));

const HeaderBox = styled(Box)(({ theme }) => ({
  padding: theme.spacing(2, 2, 1, 2),
  flexShrink: 0,
  backgroundColor: theme.palette.mode === 'dark' 
    ? 'rgba(10, 25, 41, 0.8)' 
    : 'rgba(255,255,255,0.9)',
  borderTopLeftRadius: theme.spacing(2),
  borderTopRightRadius: theme.spacing(2),
  zIndex: 5,
  position: 'relative'
}));

const TableBox = styled(Box)(({ theme }) => ({
  flex: 1,
  padding: theme.spacing(0, 2, 2, 2),
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  position: 'relative',
  touchAction: 'pan-y',
  overflowX: 'hidden',
  overflowY: 'auto',
  WebkitOverflowScrolling: 'touch',
  '&::-webkit-scrollbar': {
    width: '6px',
    height: '6px'
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: theme.palette.mode === 'dark' 
      ? 'rgba(255, 255, 255, 0.2)' 
      : 'rgba(0, 0, 0, 0.2)',
    borderRadius: '3px'
  }
}));

export default function CallPutInstruments({
  row,
  underlyingToken,
  exchange,
  token,
  instrument,
  underlineTradingSymbol
}) {
  const optionGreeksEnabled = useSelector(
    (state) => state.configs?.appConfig?.optionGreeksEnabled
  );

  const processedStrikes = React.useMemo(() => {
    if (!row?.strikes || !Array.isArray(row.strikes)) {
      return [];
    }

    return row.strikes.map(strike => ({
      strike_price: strike.strike_price,
      call_option: {
        ...strike.call_option,
        exchange: strike.call_option?.exchange,
        token: strike.call_option?.token,
        lotsize: instrument?.board_lot_quantity,
        tick_size: instrument?.tick_size,
        execution: strike.call_option?.execution || "REGULAR",
        tradable: instrument?.tradable
      },
      put_option: {
        ...strike.put_option,
        exchange: strike.put_option?.exchange,
        token: strike.put_option?.token,
        lotsize: instrument?.board_lot_quantity,
        tick_size: instrument?.tick_size,
        execution: strike.put_option?.execution || "REGULAR",
        tradable: instrument?.tradable
      }
    }));
  }, [row?.strikes, exchange]);

  return (
    <StyledBox>
      <HeaderBox>
        <Grid
          container
          direction="row"
          justifyContent="space-between"
          alignItems="stretch"
          sx={{ backgroundColor: 'transparent'}}
        >
          <Grid item>
            <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
              Calls
            </Typography>
          </Grid>
          <Grid item>
            <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
              Puts
            </Typography>
          </Grid>
        </Grid>
      </HeaderBox>

      <TableBox>
        <OptionTbl
          underlyingToken={underlyingToken}
          arrRows={processedStrikes}
          callHeaders={optionGreeksEnabled ? callGreekHeaders : callHeaders}
          putHeaders={optionGreeksEnabled ? putGreekHeaders : putHeaders} 
          exchange={exchange}
          token={token}
        />
      </TableBox>
    </StyledBox>
  );
} 